import { ServerURL } from "./settings";
import { sendRequestWithAuth } from "../common/sendRequest";

export const getBannedDevices = () =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "get_banned_devices",
    }),
  });

export const getBannedDevice = (id) =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "get_banned_device_by_id",
      id,
    }),
  });

export const addBannedDevice = (deviceId, banStatus) =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "add_banned_device",
      device_id: deviceId,
      ban_status: banStatus,
    }),
  });

export const editBannedDevice = (id, banStatus) =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "edit_banned_device",
      id,
      ban_status: banStatus,
    }),
  });

export const getBannedDeviceHistory = (banListId) =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "get_banned_device_history",
      ban_list_id: banListId,
    }),
  });

export const getBannedDeviceHistoryById = (id) =>
  sendRequestWithAuth(ServerURL, {
    method: "POST",
    body: JSON.stringify({
      operation: "get_banned_device_history_by_id",
      id,
    }),
  });



// WEBPACK FOOTER //
// ./src/services/ban.js